import Localization from "../../localization";
import { Text } from "../../components";
import { Constants } from "../../utils";
import React from "react";

const Other = ({ subheading = "", ...props }) => {
  return (
    <div {...props}>
      {!!subheading && (
        <Text
          weight={600}
          type="secondary"
          className="m-15-t m-10-b"
          children={subheading}
        />
      )}
      <Text
        weight={400}
        type="secondary"
        children={Localization.configure_device.other_description}
      />
      <Text
        weight={700}
        className="m-10-t"
        children={Constants.Project.phones.contact}
      />
      <Text
        weight={700}
        decoration="underline"
        className="cursor-pointer"
        children={Constants.Project.emails.contact}
        onClick={() =>
          window.open(`mailto:${Constants.Project.emails.contact}`)
        }
      />
    </div>
  );
};

export default Other;
